import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { User } from '../../app/models/user.model';
import { UserFactory } from '../../app/models/user.factory';
import { UserDetailsPage } from '../user-details/user-details';

import { Authentication } from '../../providers/authentication';
import { MystopiaUsers } from '../../providers/mystopia-users';

/*
  Generated class for the Users page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-users',
  templateUrl: 'users.html'
})
export class UsersPage {
  users: User[] = [];
  originalUsers: User[] = [];
  searchQuery: string = '';

  constructor(
    private navCtrl: NavController,
    private navParams: NavParams,
    private authService: Authentication,
    private mystopiaUsers: MystopiaUsers) {}

  ionViewCanEnter() {
    console.info('ionViewCanEnter UsersPage');
    return this.authService.isAuthenticated().toPromise();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad UsersPage');
  }

  ionViewDidEnter() {
    console.log('ionViewDidEnter UsersPage');
    this.mystopiaUsers.getUsers()
    .subscribe(users => {
      this.users = this.usersDataToUsers(users);
      this.originalUsers = this.users;
    });
  }

  doRefresh(refresher) {
    console.log('Begin async operation', refresher);

    this.getUsers().add(() => {
      console.log('Async operation has ended');
      refresher.complete();
    });
  }

  getUsers() {
    return this.mystopiaUsers.getUsers()
    .subscribe(users => {
      this.users = this.usersDataToUsers(users);
      this.originalUsers = this.users;
    });
  }

  goToDetails(user: User) {
    this.navCtrl.push(UserDetailsPage, { userId: user.email });
  }

  search() {
    let searchQuery = this.searchQuery;
    if (searchQuery.trim() === '') {
      this.users = this.originalUsers;
    } else {
      this.mystopiaUsers.searchUsers(searchQuery)
        .subscribe(users => {
          this.users = this.usersDataToUsers(users);
        });
    }
  }

  userDataToUser(userData): User {
    let user = new UserFactory().createUser(userData);
    return user;
  }

  usersDataToUsers(usersData) {
    let users = [];
    usersData.forEach((userData) => {
      users.push(this.userDataToUser(userData));
    });
    return users;
  }
}



// WEBPACK FOOTER //
// ./src/pages/users/users.ts